import CityPageTemplate from "../city-template/CityPageTemplate";
import { sunnyvaleConfig } from "./data";

export default function SunnyvalePage() {
  return <CityPageTemplate config={sunnyvaleConfig} />;
}